import { render, staticRenderFns } from "./GlobalMailing.vue?vue&type=template&id=5ff40323&"
import script from "./GlobalMailing.vue?vue&type=script&lang=js&"
export * from "./GlobalMailing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports